var XPortal = XPortal || {};
XPortal.CalendarPicker = (function () {
    var self = {
        ControlSelector: ".data-xcalendar-picker, .data-xcalendar-picker-readonly",
        LocalizePreffix: "XPortal.Frontend.DateTimePicker.",
        LocalizeKeys: {
            today: 'Today'
        },
        LocalizationResult: null,
        _localizationPromise: null,

        Init: function (container) {
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            var modelName = XPortal.Store.getModelName(container[0].id);
            container.find(XPortal.CalendarPicker.ControlSelector).each(function (ip, element) {
                ensureLocalization().then(function () {
                    XPortal.CalendarPicker.initFor(element, modelName);
                });
            });
        },
        dwToDayNumber: function (dn) {
            if (dn === "su") return 7;
            if (dn === "mo") return 1;
            if (dn === "tu") return 2;
            if (dn === "we") return 3;
            if (dn === "th") return 4;
            if (dn === "fr") return 5;
            if (dn === "sa") return 6;
        },
        initFor: function (element, modelName) {
            var xcontainer = jQuery(element);
            var el = xcontainer.find(".detail-field");
            const sttgs = XPortal.Main.GetSettingsFor(el);

            var tmpDateVal = sttgs.value;
            if (tmpDateVal && tmpDateVal.length > 0)
                tmpDateVal = XPortal.Utils.TransformDateTime(tmpDateVal, (sttgs.type === "datetime" ? null : "YYYY-MM-DD"), false, false, true, false);

            sttgs.value = (typeof tmpDateVal.toDate === "function" ? tmpDateVal.toDate() : tmpDateVal);
            sttgs.dbtoday = el.attr("data-disable-btoday") === "1";
            sttgs.dtoday = el.attr("data-disable-today") === "1";
            sttgs.datoday = el.attr("data-disable-atoday") === "1";
            sttgs.dwday = el.attr("data-disable-wdays").split(",");
            sttgs.weekNumber = el.attr("data-show-week") === "1";
            sttgs.selectable = el.attr("readonly") ? false : "single";

            sttgs.change = function () {
                var dateTimeVal = this.value();
                var value = dateTimeVal === null ? '' : XPortal.Utils.customISOstring(dateTimeVal, dateTimeVal.getTimezoneOffset());
                XPortal.Store.FieldEvent(element, value, modelName, sttgs);
            };
            XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el }, function render(value) {
                if (el && value)
                    xcontainer?.data('kendoCalendar')?.value(new Date(value));
            });

            sttgs.dwday = _.map(sttgs.dwday, self.dwToDayNumber);
            sttgs.disableDates = function (date) {
                if (!date) return false;
                var daysDiff = moment().diff(date, 'days');
                if (sttgs.dtoday && daysDiff == 0) return true;
                if (sttgs.dbtoday && daysDiff > 0) return true;
                if (sttgs.datoday && daysDiff < 0) return true;
                var weekDay = moment(date).isoWeekday();
                var blocked = _.find(sttgs.dwday, function (bd) { return bd == weekDay; });
                if (blocked > 0) return true;
                return false;
            };
            sttgs.componentType = "modern";
            sttgs.messages = self.LocalizationResult.localizedTexts;

            xcontainer.kendoCalendar(sttgs);
            const calendar = xcontainer.data("kendoCalendar");
            if (calendar && calendar.value()) {
                calendar.navigate(calendar.value());
            }
            if (sttgs.editable)
                el.closest(".k-widget").on("click", function () { el.data("kendoCalendar").open(); });
        },
        ensurePrototypeInited: function () {
            $.extend(true, kendo.ui.Calendar.prototype.options.messages, {
                today: self.LocalizationResult.localizedTexts.today,
            });
        }
    };
    function ensureLocalization() {
        if (!self._localizationPromise) {
            self._localizationPromise = XPortal.Localization.EnsureLocalizedTexts(self.LocalizePreffix, self.LocalizeKeys)
                .then(function (result) {
                    self.LocalizationResult = result;
                    self.ensurePrototypeInited();
                    return result;
                })
                .catch(function (error) {
                    self._localizationPromise = null;
                    throw error;
                });
        }

        return self._localizationPromise;
    };
    return self;
}());
